import { cn } from "@ui/lib";

/**
 * What the call service does between a caller's last word and the assistant's first, drawn to
 * scale: a 300 ms pause starts the work, 650 ms ends the turn (apps/voice), and the answer
 * follows in under a second (the figure Hephon states publicly).
 */
const SCALE_MS = 1000;

const MARKS = [
	{
		at: 0,
		label: "0 s",
		title: "The caller stops",
		text: "Their words were transcribed while they spoke.",
	},
	{
		at: 300,
		label: "0.3 s",
		title: "A pause is heard",
		text: "The product search starts before they have finished.",
	},
	{
		at: 650,
		label: "0.65 s",
		title: "The turn is over",
		text: "A sentence cut off half way would be held for the rest.",
	},
	{
		at: 900,
		label: "Under 1 s",
		title: "It answers",
		text: "The assistant's first spoken word.",
		strong: true,
	},
];

export function LatencyTimeline() {
	return (
		<figure className="mk-rise">
			<div className="relative pt-2">
				<div className="relative h-2 rounded-full bg-(--mk-mist)">
					<div
						className="absolute inset-y-0 left-0 rounded-full bg-(--mk-signal)"
						style={{ width: `${(900 / SCALE_MS) * 100}%` }}
					/>
					{MARKS.map((mark) => (
						<span
							key={mark.at}
							aria-hidden
							className={cn(
								"absolute top-1/2 size-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-(--mk-white)",
								mark.strong
									? "bg-(--mk-ink)"
									: "bg-(--mk-signal)",
							)}
							style={{ left: `${(mark.at / SCALE_MS) * 100}%` }}
						/>
					))}
				</div>
				<div className="mt-2 flex justify-between text-(--mk-faint) text-[12px] tabular-nums">
					<span>0 s</span>
					<span>0.25 s</span>
					<span>0.5 s</span>
					<span>0.75 s</span>
					<span>1 s</span>
				</div>
			</div>
			<ol className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
				{MARKS.map((mark) => (
					<li
						key={mark.at}
						className="border-(--mk-line) border-t pt-4"
					>
						<p
							className={cn(
								"font-semibold text-[28px] tracking-[-0.04em] tabular-nums",
								mark.strong
									? "text-(--mk-ink)"
									: "text-(--mk-signal)",
							)}
						>
							{mark.label}
						</p>
						<p className="mt-1 font-semibold text-[17px]">
							{mark.title}
						</p>
						<p className="mt-1 text-(--mk-muted) text-[15px] leading-relaxed">
							{mark.text}
						</p>
					</li>
				))}
			</ol>
		</figure>
	);
}
